import { useEffect, useState } from 'react';
import './HomePage.css';
import heroMainVideo from './assets/videos/main_video.mp4';
import newsImage1 from './assets/news/news1.jpg';
import newsImage2 from './assets/news/new2.jpg';
import newsImage3 from './assets/news/news3.jpg';
import newsImage4 from './assets/news/news4.jpg';
import newsImage5 from './assets/news/news5.jpg';
import newsImage6 from './assets/news/news6.jpg';
import newsImage7 from './assets/news/news7.jpg';
import newsImage8 from './assets/news/news8.jpg';

const translations = {
  en: {
    languageLabel: 'Language',
    heroTaglinePrefix: 'SCHOOL FOR',
    heroTaglineAccent: 'LIFE',
    heroPhilosophy: 'FAITH, FORTITUDE AND FULFILMENT',
    quickLinksKicker: 'Quick Access',
    quickLinksTitle: 'Everything you need at a glance',
    applyNowTitle: 'Apply Now',
    applyNowText: 'Begin the admissions journey with a simple and guided first step.',
    schoolCalendarTitle: 'School Calendar',
    schoolCalendarText: 'View academic schedules, events, competitions, assemblies, cultural days, and field trips.',
    contactUsTitle: 'Contact Us',
    contactUsText: 'Connect with our team for enquiries, visits, or admissions support.',
    highlightsKicker: 'Highlights',
    highlightsTitle: 'Today on campus',
    highlightsIntro: 'Live updates and featured moments that reflect the rhythm of the school day.',
    highlightsLiveLabel: 'Live update',
    highlightsNote: 'Auto-updates based on the day and rotates every few seconds.',
    highlightsItems: [
      {
        title: 'Morning assembly and student leadership',
        summary: 'A calm start to the day with announcements, values, and a shared school focus.',
      },
      {
        title: 'Academic focus and classroom engagement',
        summary: 'Teachers guide targeted learning, support sessions, and active classroom discussion.',
      },
      {
        title: 'Clubs, creativity, and collaboration',
        summary: 'Students explore interests through clubs, projects, and hands-on teamwork.',
      },
      {
        title: 'Arts, culture, and community spirit',
        summary: 'A space for cultural days, performances, and expression that builds confidence.',
      },
      {
        title: 'Reflection, chapel, and school community care',
        summary: 'The week closes with gratitude, reflection, and care for the wider school family.',
      },
    ],
    newsCountdownKicker: 'What Is Next',
    newsCountdownTitle: 'News and opening day countdown',
    newsCountdownIntro: 'Stay updated with the latest school stories while we count down to opening day.',
    latestNewsLabel: 'Latest News',
    newsItems: [
      {
        date: 'April 12, 2026',
        title: 'Parent orientation week begins',
        summary: 'Families are invited to school tours, programme briefings, and classroom introductions.',
        fullContent: `
          <p>We are excited to welcome all families to our comprehensive Parent Orientation Week, designed to help you understand our educational philosophy, meet our dedicated staff, and explore our state-of-the-art facilities.</p>
          
          <p>Throughout the week, parents will have the opportunity to participate in guided school tours, attend detailed programme briefings covering our curriculum approach, and visit classrooms where their children will learn and grow. Our experienced teachers and administrators will be available to answer questions and provide insights into daily school life.</p>
          
          <p>This orientation is an essential first step in building a strong partnership between home and school. We believe that when families and educators work together, students thrive academically, socially, and emotionally.</p>
          
          <p>Sessions will be held daily from 9:00 AM to 3:00 PM. Light refreshments will be provided. We look forward to meeting you and beginning this exciting educational journey together.</p>
        `,
      },
      {
        date: 'April 18, 2026',
        title: 'Student talent showcase',
        summary: 'A celebration of music, performance, and student creativity across grade levels.',
        fullContent: `
          <p>Join us for an inspiring evening as our students take center stage to showcase their remarkable talents in music, drama, dance, and visual arts. This annual event celebrates the diverse creative abilities of our student body and demonstrates the fruits of their dedication and practice.</p>
          
          <p>The showcase will feature performances from students across all grade levels, including solo musical performances, ensemble pieces, dramatic readings, dance choreography, and displays of visual artwork. Each performance reflects not only individual talent but also the collaborative spirit that defines our school community.</p>
          
          <p>Our arts programme is designed to nurture creativity, build confidence, and provide students with opportunities to express themselves in meaningful ways. Through regular practice, constructive feedback, and supportive encouragement, students develop skills that extend far beyond the stage or canvas.</p>
          
          <p>The event will be held in our main auditorium at 6:00 PM. Admission is free, and all family members are welcome. Light refreshments will be available during intermission.</p>
        `,
      },
      {
        date: 'April 24, 2026',
        title: 'Community service collaboration',
        summary: 'Students join outreach initiatives that strengthen empathy and social responsibility.',
        fullContent: `
          <p>Our students will participate in meaningful community service projects designed to foster empathy, social responsibility, and a deeper understanding of the world beyond our campus. These initiatives are a core component of our character education programme.</p>
          
          <p>This month's collaboration includes partnerships with local charities, environmental conservation efforts, and support for elderly community members. Students will work in small groups, guided by teachers and community leaders, to make a tangible positive impact.</p>
          
          <p>Through hands-on service experiences, students learn the value of compassion, teamwork, and civic engagement. They develop a sense of agency and understand that even small actions can create meaningful change. These lessons complement our academic curriculum and help shape well-rounded, socially conscious individuals.</p>
          
          <p>Parents are encouraged to support their children's participation and discuss their experiences at home. Together, we are building a generation of thoughtful, engaged citizens who understand their responsibility to contribute to the common good.</p>
        `,
      },
    ],
    countdownLabel: 'Opening Day Countdown',
    countdownTitle: 'School Opening Day',
    countdownDateText: 'Monday, July 13, 2026',
    countdownDescription: 'We are preparing every detail to welcome students and families with excellence.',
    countdownDays: 'Days',
    countdownHours: 'Hours',
    countdownMinutes: 'Minutes',
    countdownSeconds: 'Seconds',
    countdownComplete: 'Opening day has arrived. Welcome to the new school year.',
  },
  id: {
    languageLabel: 'Bahasa',
    heroTaglinePrefix: 'SEKOLAH UNTUK',
    heroTaglineAccent: 'HIDUP',
    heroPhilosophy: 'IMAN, KETEGUHAN, DAN PENCAPAIAN',
    quickLinksKicker: 'Akses Cepat',
    quickLinksTitle: 'Semua informasi penting dalam satu tempat',
    applyNowTitle: 'Daftar Sekarang',
    applyNowText: 'Mulai proses pendaftaran dengan langkah awal yang mudah dan terarah.',
    schoolCalendarTitle: 'Kalender Sekolah',
    schoolCalendarText: 'Lihat jadwal akademik, acara, kompetisi, upacara, hari budaya, dan karyawisata.',
    contactUsTitle: 'Hubungi Kami',
    contactUsText: 'Hubungi tim kami untuk pertanyaan, kunjungan, atau bantuan pendaftaran.',
    highlightsKicker: 'Sorotan',
    highlightsTitle: 'Aktivitas hari ini di sekolah',
    highlightsIntro: 'Update langsung dan momen utama yang mengikuti ritme kegiatan sekolah.',
    highlightsLiveLabel: 'Update langsung',
    highlightsNote: 'Memperbarui isi sesuai hari dan berganti otomatis setiap beberapa detik.',
    highlightsItems: [
      {
        title: 'Apel pagi dan kepemimpinan siswa',
        summary: 'Awal hari yang tenang dengan pengumuman, nilai karakter, dan fokus bersama.',
      },
      {
        title: 'Fokus akademik dan keterlibatan kelas',
        summary: 'Guru memandu pembelajaran terarah, sesi pendampingan, dan diskusi aktif di kelas.',
      },
      {
        title: 'Klub, kreativitas, dan kolaborasi',
        summary: 'Siswa mengeksplorasi minat melalui klub, proyek, dan kerja tim secara langsung.',
      },
      {
        title: 'Seni, budaya, dan semangat kebersamaan',
        summary: 'Ruang untuk cultural day, penampilan, dan ekspresi diri yang membangun percaya diri.',
      },
      {
        title: 'Refleksi, chapel, dan kepedulian komunitas sekolah',
        summary: 'Akhir pekan sekolah ditutup dengan rasa syukur, refleksi, dan perhatian bagi keluarga besar sekolah.',
      },
    ],
    newsCountdownKicker: 'Selanjutnya',
    newsCountdownTitle: 'Berita dan hitung mundur hari pembukaan',
    newsCountdownIntro: 'Ikuti kabar terbaru sekolah sambil menghitung mundur menuju hari pembukaan.',
    latestNewsLabel: 'Berita Terkini',
    newsItems: [
      {
        date: '12 April 2026',
        title: 'Minggu orientasi orang tua dimulai',
        summary: 'Keluarga diundang untuk tur sekolah, penjelasan program, dan pengenalan kelas.',
        fullContent: `
          <p>Kami sangat senang menyambut semua keluarga dalam Minggu Orientasi Orang Tua yang komprehensif, dirancang untuk membantu Anda memahami filosofi pendidikan kami, bertemu dengan staf kami yang berdedikasi, dan menjelajahi fasilitas kami yang canggih.</p>
          
          <p>Sepanjang minggu, orang tua akan memiliki kesempatan untuk berpartisipasi dalam tur sekolah terpandu, menghadiri penjelasan program terperinci yang mencakup pendekatan kurikulum kami, dan mengunjungi ruang kelas di mana anak-anak mereka akan belajar dan berkembang. Guru dan administrator berpengalaman kami akan tersedia untuk menjawab pertanyaan dan memberikan wawasan tentang kehidupan sekolah sehari-hari.</p>
          
          <p>Orientasi ini adalah langkah pertama yang penting dalam membangun kemitraan yang kuat antara rumah dan sekolah. Kami percaya bahwa ketika keluarga dan pendidik bekerja sama, siswa berkembang secara akademis, sosial, dan emosional.</p>
          
          <p>Sesi akan diadakan setiap hari dari pukul 09:00 hingga 15:00. Makanan ringan akan disediakan. Kami menantikan untuk bertemu Anda dan memulai perjalanan pendidikan yang menarik ini bersama-sama.</p>
        `,
      },
      {
        date: '18 April 2026',
        title: 'Pentas bakat siswa',
        summary: 'Perayaan musik, penampilan, dan kreativitas siswa dari berbagai jenjang.',
        fullContent: `
          <p>Bergabunglah dengan kami untuk malam yang menginspirasi saat siswa kami tampil di panggung untuk menunjukkan bakat luar biasa mereka dalam musik, drama, tari, dan seni visual. Acara tahunan ini merayakan kemampuan kreatif yang beragam dari siswa kami dan menunjukkan hasil dari dedikasi dan latihan mereka.</p>
          
          <p>Pertunjukan akan menampilkan penampilan dari siswa di semua tingkat kelas, termasuk pertunjukan musik solo, karya ensemble, pembacaan dramatis, koreografi tari, dan pameran karya seni visual. Setiap pertunjukan mencerminkan tidak hanya bakat individu tetapi juga semangat kolaboratif yang mendefinisikan komunitas sekolah kami.</p>
          
          <p>Program seni kami dirancang untuk memelihara kreativitas, membangun kepercayaan diri, dan memberikan siswa kesempatan untuk mengekspresikan diri mereka dengan cara yang bermakna. Melalui latihan rutin, umpan balik konstruktif, dan dorongan yang mendukung, siswa mengembangkan keterampilan yang jauh melampaui panggung atau kanvas.</p>
          
          <p>Acara akan diadakan di auditorium utama kami pada pukul 18:00. Masuk gratis, dan semua anggota keluarga dipersilakan. Makanan ringan akan tersedia selama istirahat.</p>
        `,
      },
      {
        date: '24 April 2026',
        title: 'Kolaborasi layanan masyarakat',
        summary: 'Siswa terlibat dalam inisiatif sosial yang menumbuhkan empati dan tanggung jawab.',
        fullContent: `
          <p>Siswa kami akan berpartisipasi dalam proyek layanan masyarakat yang bermakna yang dirancang untuk menumbuhkan empati, tanggung jawab sosial, dan pemahaman yang lebih dalam tentang dunia di luar kampus kami. Inisiatif ini adalah komponen inti dari program pendidikan karakter kami.</p>
          
          <p>Kolaborasi bulan ini mencakup kemitraan dengan badan amal lokal, upaya konservasi lingkungan, dan dukungan untuk anggota masyarakat lanjut usia. Siswa akan bekerja dalam kelompok kecil, dipandu oleh guru dan pemimpin masyarakat, untuk membuat dampak positif yang nyata.</p>
          
          <p>Melalui pengalaman layanan langsung, siswa belajar nilai kasih sayang, kerja tim, dan keterlibatan sipil. Mereka mengembangkan rasa agensi dan memahami bahwa bahkan tindakan kecil dapat menciptakan perubahan yang berarti. Pelajaran ini melengkapi kurikulum akademis kami dan membantu membentuk individu yang berimbang dan sadar sosial.</p>
          
          <p>Orang tua didorong untuk mendukung partisipasi anak-anak mereka dan mendiskusikan pengalaman mereka di rumah. Bersama-sama, kami membangun generasi warga negara yang bijaksana dan terlibat yang memahami tanggung jawab mereka untuk berkontribusi pada kebaikan bersama.</p>
        `,
      },
    ],
    countdownLabel: 'Hitung Mundur Pembukaan',
    countdownTitle: 'Hari Pembukaan Sekolah',
    countdownDateText: 'Senin, 13 Juli 2026',
    countdownDescription: 'Kami menyiapkan setiap detail untuk menyambut siswa dan keluarga dengan maksimal.',
    countdownDays: 'Hari',
    countdownHours: 'Jam',
    countdownMinutes: 'Menit',
    countdownSeconds: 'Detik',
    countdownComplete: 'Hari pembukaan telah tiba. Selamat datang di tahun ajaran baru.',
  },
};

const highlightPhotos = [
  newsImage1,
  newsImage2,
  newsImage3,
  newsImage4,
  newsImage5,
  newsImage6,
  newsImage7,
  newsImage8,
];

function HomePage({ language = 'en', onLanguageChange, onNavigate }) {
  const [localLanguage, setLocalLanguage] = useState(language);
  const activeLanguage = onLanguageChange ? language : localLanguage;
  const setLanguage = onLanguageChange || setLocalLanguage;
  const [highlightIndex, setHighlightIndex] = useState(0);
  const [now, setNow] = useState(() => Date.now());
  const copy = translations[activeLanguage];
  const highlightItems = copy.highlightsItems;
  const openingDayTime = new Date('2026-07-13T07:00:00+07:00').getTime();

  useEffect(() => {
    if (!onLanguageChange && language !== localLanguage) {
      setLocalLanguage(language);
    }
  }, [language, onLanguageChange, localLanguage]);

  useEffect(() => {
    const dayIndex = new Date().getDay();
    setHighlightIndex(dayIndex % highlightItems.length);

    const intervalId = setInterval(() => {
      setHighlightIndex((currentIndex) => (currentIndex + 1) % highlightItems.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [highlightItems.length, activeLanguage]);

  useEffect(() => {
    const tickerId = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(tickerId);
  }, []);

  const activeHighlight = highlightItems[highlightIndex];
  const activeHighlightPhoto = highlightPhotos[highlightIndex % highlightPhotos.length];
  const countdownRemaining = Math.max(0, openingDayTime - now);
  const countdownDays = Math.floor(countdownRemaining / (1000 * 60 * 60 * 24));
  const countdownHours = Math.floor((countdownRemaining / (1000 * 60 * 60)) % 24);
  const countdownMinutes = Math.floor((countdownRemaining / (1000 * 60)) % 60);
  const countdownSeconds = Math.floor((countdownRemaining / 1000) % 60);
  const isOpeningDayReached = countdownRemaining === 0;

  return (
    <div className="homepage">
      <section className="hero-section hero-fullscreen">
        <div className="hero-language-switcher" aria-label="Language switcher">
          <span className="hero-language-label">{copy.languageLabel}</span>
          <div className="hero-language-options" role="group" aria-label="Select page language">
            <button
              type="button"
              className={`hero-language-button ${activeLanguage === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              EN
            </button>
            <button
              type="button"
              className={`hero-language-button ${activeLanguage === 'id' ? 'active' : ''}`}
              onClick={() => setLanguage('id')}
            >
              ID
            </button>
          </div>
        </div>

        <div className="hero-video-bg" aria-hidden="true">
          <video className="hero-video-element" autoPlay loop muted playsInline preload="metadata">
            <source src={heroMainVideo} type="video/mp4" />
          </video>
        </div>
        <div className="hero-overlay" aria-hidden="true" />
        <div className="hero-content hero-content-layout">
          <article className="hero-message-center">
            <p className="hero-tagline">
              {copy.heroTaglinePrefix} <span className="hero-tagline-accent">{copy.heroTaglineAccent}</span>
            </p>
            <p className="hero-philosophy">
              {copy.heroPhilosophy}
            </p>
          </article>
        </div>
      </section>

      <section className="quick-links-section" aria-label="Quick Links">
        <div className="quick-links-shell">
          <div className="quick-links-header">
            <p className="quick-links-kicker">{copy.quickLinksKicker}</p>
            <h2 className="quick-links-title">{copy.quickLinksTitle}</h2>
          </div>

          <div className="quick-links-grid">
            <button
              className="quick-link-card"
              type="button"
              onClick={() => onNavigate && onNavigate('register')}
            >
              <div className="shimmer-effect"></div>
              <div className="quick-link-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14,2 14,8 20,8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10,9 9,9 8,9"/>
                </svg>
              </div>
              <span className="quick-link-label">01</span>
              <h3>{copy.applyNowTitle}</h3>
              <p>{copy.applyNowText}</p>
            </button>

            <a className="quick-link-card" href="#school-calendar">
              <div className="shimmer-effect"></div>
              <div className="quick-link-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                  <line x1="16" y1="2" x2="16" y2="6"/>
                  <line x1="8" y1="2" x2="8" y2="6"/>
                  <line x1="3" y1="10" x2="21" y2="10"/>
                  <path d="M8 14h.01"/>
                  <path d="M12 14h.01"/>
                  <path d="M16 14h.01"/>
                  <path d="M8 18h.01"/>
                  <path d="M12 18h.01"/>
                </svg>
              </div>
              <span className="quick-link-label">02</span>
              <h3>{copy.schoolCalendarTitle}</h3>
              <p>{copy.schoolCalendarText}</p>
            </a>

            <button className="quick-link-card" onClick={() => {
              // Simulate clicking the Contact us button in navbar
              const contactButton = document.querySelector('.nav-cta');
              if (contactButton) {
                contactButton.click();
              }
            }}>
              <div className="shimmer-effect"></div>
              <div className="quick-link-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
              </div>
              <span className="quick-link-label">03</span>
              <h3>{copy.contactUsTitle}</h3>
              <p>{copy.contactUsText}</p>
            </button>
          </div>
        </div>
      </section>

      <section className="highlights-section" aria-label="Highlights">
        <div className="highlights-shell">
          <div className="highlights-header">
            <p className="highlights-kicker">{copy.highlightsKicker}</p>
            <h2 className="highlights-title">{copy.highlightsTitle}</h2>
            <p className="highlights-intro">{copy.highlightsIntro}</p>
          </div>

          <div className="highlights-grid">
            <article className="highlight-feature-card">
              <div className="highlight-feature-image-wrap">
                <img
                  src={activeHighlightPhoto}
                  alt={activeHighlight.title}
                  className="highlight-feature-image"
                />
                <div className="highlight-image-overlay"></div>
              </div>
              <div className="highlight-feature-content">
                <div className="highlight-feature-topline">
                  <span className="highlight-live-pill">
                    <span className="live-dot"></span>
                    {copy.highlightsLiveLabel}
                  </span>
                  <span className="highlight-live-note">{copy.highlightsNote}</span>
                </div>
                <h3>{activeHighlight.title}</h3>
                <p>{activeHighlight.summary}</p>
                <div className="highlight-progress" aria-hidden="true">
                  {highlightItems.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      className={`highlight-progress-dot ${index === highlightIndex ? 'active' : ''}`}
                      onClick={() => setHighlightIndex(index)}
                      aria-label={`View highlight ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </article>

            <div className="highlight-news-list-wrapper">
              <div className="highlight-news-list" aria-label="More highlights">
                {highlightItems.map((item, index) => (
                  <article 
                    key={item.title} 
                    className={`highlight-news-item ${index === highlightIndex ? 'active' : ''}`}
                    onClick={() => setHighlightIndex(index)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        setHighlightIndex(index);
                      }
                    }}
                  >
                    <div className="highlight-news-item-header">
                      <span className="highlight-news-index">0{index + 1}</span>
                      <svg className="highlight-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <polyline points="9 18 15 12 9 6"/>
                      </svg>
                    </div>
                    <img
                      src={highlightPhotos[index % highlightPhotos.length]}
                      alt={item.title}
                      className="highlight-news-thumb"
                    />
                    <div className="highlight-news-content">
                      <h3>{item.title}</h3>
                      <p>{item.summary}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="news-countdown-section" aria-label="News and countdown">
        <div className="news-countdown-shell">
          <div className="news-countdown-header">
            <p className="news-countdown-kicker">{copy.newsCountdownKicker}</p>
            <h2 className="news-countdown-title">{copy.newsCountdownTitle}</h2>
            <p className="news-countdown-intro">{copy.newsCountdownIntro}</p>
          </div>

          <div className="news-countdown-grid">
            <article className="news-panel-card">
              <div className="news-panel-header">
                <h3 className="news-panel-title">{copy.latestNewsLabel}</h3>
                <button 
                  className="news-see-all-btn"
                  onClick={() => {
                    window.location.hash = '#news-all';
                    window.location.reload();
                  }}
                >
                  <span>{activeLanguage === 'en' ? 'See All' : 'Lihat Semua'}</span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </button>
              </div>
              <div className="news-list">
                {copy.newsItems.map((item, index) => (
                  <article 
                    key={item.title} 
                    className="news-item-card"
                    onClick={() => {
                      window.location.hash = `#news/${index + 1}`;
                      window.location.reload();
                    }}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        window.location.hash = `#news/${index + 1}`;
                        window.location.reload();
                      }
                    }}
                  >
                    <img
                      src={highlightPhotos[(index + 2) % highlightPhotos.length]}
                      alt={item.title}
                      className="news-item-image"
                    />
                    <div>
                      <p className="news-item-date">{item.date}</p>
                      <h4>{item.title}</h4>
                      <p>{item.summary}</p>
                    </div>
                  </article>
                ))}
              </div>
            </article>

            <article className="countdown-panel-card">
              <p className="countdown-label">{copy.countdownLabel}</p>
              <h3>{copy.countdownTitle}</h3>
              <p className="countdown-date-text">{copy.countdownDateText}</p>
              <p className="countdown-description">{copy.countdownDescription}</p>

              {isOpeningDayReached ? (
                <p className="countdown-complete">{copy.countdownComplete}</p>
              ) : (
                <div className="countdown-grid" aria-label="Opening day countdown values">
                  <div className="countdown-value-box">
                    <strong>{String(countdownDays).padStart(2, '0')}</strong>
                    <span>{copy.countdownDays}</span>
                  </div>
                  <div className="countdown-value-box">
                    <strong>{String(countdownHours).padStart(2, '0')}</strong>
                    <span>{copy.countdownHours}</span>
                  </div>
                  <div className="countdown-value-box">
                    <strong>{String(countdownMinutes).padStart(2, '0')}</strong>
                    <span>{copy.countdownMinutes}</span>
                  </div>
                  <div className="countdown-value-box">
                    <strong>{String(countdownSeconds).padStart(2, '0')}</strong>
                    <span>{copy.countdownSeconds}</span>
                  </div>
                </div>
              )}
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
